import { environment } from '../../../environments/environment';

export interface EnvironmentInfo {
  /** True when the API in use is the live (production) API. */
  isLive: boolean;
  /** Short label for display, e.g. 'Live' or 'Dev'. */
  label: string;
  /** The Admin Tool site that matches the API in use. */
  siteUrl: string;
  /** The API the app is currently pointed at. */
  apiUrl: string;
}

const DEV_SITE_URL = 'https://at-test.thebenchmarkingnetwork.co.uk/';
const LIVE_SITE_URL = 'https://at.thebenchmarkingnetwork.co.uk/';

/**
 * Works out whether the app is pointed at the dev or live API.
 * The API URL is switched manually in environments.ts, so this reads the
 * URL rather than the build configuration.
 */
export function getEnvironmentInfo(): EnvironmentInfo {
  const apiUrl = environment.nhsApiUrl || '';
  const isLive = !/dev|test|localhost/i.test(apiUrl);

  return {
    isLive,
    label: isLive ? 'Live' : 'Dev',
    siteUrl: isLive ? LIVE_SITE_URL : DEV_SITE_URL,
    apiUrl,
  };
}
